( function () {
	const facilityResultsContainers = document.querySelectorAll( '.facility-tabs__panel, .saved-facilities-template' );

	if( !facilityResultsContainers || !facilityResultsContainers.length ) { return; }

	const readMoreSelector = '.facility-result__desc-toggle';
	const descWrapperClass = '.facility-result__desc-section';
	const readMoreVisibleClass = 'facility-result__desc-toggle--visible';

	const moreTags = '.facility-result__tag-more:not([data-toggle="modal"])';
	const tagWrapper = '.facility-result__tag-group';
	const moreTagsVisibleClass = 'facility-result__tag-group--active';
	
	handleNewResultsSet();
	
	let timer;
	window.addEventListener( 'resize', function() {
		if( timer ) { clearTimeout( timer ); }
		timer = setTimeout( readMoreVisible, 300 );
	} );

	facilityResultsContainers.forEach( function( container ) {
		let resultWrap = container.querySelector( '.facility-result__wrap' );

		if( resultWrap ) {
			resultWrap.addEventListener( 'click', toggleExpanded );
		}
	} );

	// fired by facilities-ajax.js
	document.body.addEventListener( 'facility-result-rendered', handleNewResultsSet );

	// fired by facilities-tabs.js
	document.body.addEventListener( 'tabchanged', handleNewResultsSet );

	// calculate again after font loads
	const fontName = window.getComputedStyle( facilityResultsContainers[0].querySelector( readMoreSelector ) ).getPropertyValue( 'font-family' ).split( ',' )[0];
	if( fontName ) {
		const fontListener = document.fonts.addEventListener( 'loadingdone', function( e ) {
			if( e.fontfaces.find( function( font ) { return font.family == fontName; } ) ) {
				document.fonts.removeEventListener( 'loadingdone', fontListener );
				readMoreVisible();
			}
		} );

		( async function() {
			await document.fonts.load( '14px ' + fontName );
		} )();
	}

	function toggleExpanded( e ) {
		const expandedClass = 'facility-result__desc-section--expanded';

		if( !( e.target.matches( readMoreSelector + ' *' ) || e.target.matches( readMoreSelector ) ) ) {
			// Didn't click the toggle, stop here
			return;
		}
		
		const descWrapper = e.target.closest( descWrapperClass );
		if( !descWrapper ) { return; }

		// Toggle expanded / collapsed
		if( descWrapper.classList.contains( expandedClass ) ) {
			descWrapper.classList.remove( expandedClass );
		} else {
			descWrapper.classList.add( expandedClass );
		}
	}

	function readMoreVisible() {
		const readMoreEles = Array.from( facilityResultsContainers ).find( function( panel ) {
			return panel.matches( '.facility-tabs__panel--active, .facility-result__set' );
		} ).querySelectorAll( readMoreSelector );

		for( const readMore of readMoreEles ) {
			readMore.classList.remove( readMoreVisibleClass );
			
			const readMoreRect = readMore.getBoundingClientRect();
			const truncateEle = readMore.closest( descWrapperClass );
			const truncateEleRect = truncateEle.getBoundingClientRect();
			const truncateEleStyles = window.getComputedStyle( truncateEle, null );
			
			const isVisible = (
				( readMoreRect.top >= truncateEleRect.top + parseFloat( truncateEleStyles.getPropertyValue( 'padding-top' ) ) )
				&& ( readMoreRect.bottom <= truncateEleRect.bottom + parseFloat( truncateEleStyles.getPropertyValue( 'padding-bottom' ) ) )
			);
			
			if( isVisible ) {
				readMore.classList.add( readMoreVisibleClass );
			} else {
				readMore.classList.remove( readMoreVisibleClass );
			}
		}
	}

	function handleNewResultsSet() {
		readMoreVisible();
		setupToggleTags();
	}

	function setupToggleTags() {
		const tagToggles = Array.from( facilityResultsContainers ).find( function( panel ) {
			return panel.matches( '.facility-tabs__panel--active, .facility-result__set' );
		} ).querySelectorAll( moreTags );

		for( const toggle of tagToggles ) {
			toggle.addEventListener( 'click', function() {
				this.closest( tagWrapper ).classList.toggle( moreTagsVisibleClass );
			} );
		}
	}
} )();